import getQuickShopHrefProductUtil from 'modules/product/utils/get-quick-shop-href'

/**
 * @param {ProductVariantCollection} productVariant
 * @returns {string}
 */
export default function getQuickShopHrefProductVariantUtil (productVariant) {
  return getQuickShopHrefProductUtil({
    productId: productVariant.product_id,
    variantId: productVariant.variant_id
  })
}
